import EventTracker from './event-tracker';

document.addEventListener('DOMContentLoaded', () => {
    const { url, category, action, viewedUUID } = window.__VUMEDI_TRACKING_EVENT_CONTEXT__;

    window.eventTracker = new EventTracker(url, category, action, viewedUUID);
});
